import './record-edit-menu.scss'

import _ from 'lodash'
import { faCheck, faTabletAlt, faTimes, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import Component from 'vue-class-component'

import { RecordLifecycleState } from '@skinsoft/types'
import { recordSelectors } from '@skinsoft/selectors'
import { RecordDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { SAVE_CURRENT_RECORD_TOPIC, TRANSITION_RECORD_TO_STATE } from '../../../../busTopics'
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'

@Component({
    components: {

    },
    props: [''],
    template: require('./record-edit-menu.html')
})
export class RecordEditMenu extends ReactiveVue {

    private get displayLocalWarning() {
        return !this.onLine || this.hasCachedUpdates
    }

    private showValidation = false;
    private recordId: string = ""
    private onLine: boolean = false;
    private hasCachedUpdates = false;
    private running = false;
    private states = ['inProgress', 'toValidated', 'validated']

    private selectedLifecycleState: RecordLifecycleState = null as any;

    private transitionCallback: () => void

    private displayStatuses = false

    // Icons 
    private checkIcon = faCheck;
    private crossIcon = faTimes;
    private warningIcon = faTabletAlt;
    private caretDownIcon = faCaretDown;
    private caretRightIcon = faCaretRight;

    private $recordDataStore: RecordDataStore
    private recordState: string = "";

    public mounted() {
        this.recordId = _.get(this.$route, 'params.recordId')
        this.subscribeTo(
            this.$recordDataStore.fetchOne(this.recordId),
            record => {
                this.recordState = recordSelectors.currentState(record, this.$i18n.locale);
                this.unsubscribeFrom('record-subscription');
            },
            'record-subscription')
        this.$recordDataStore.hasCachedUpdates(this.recordId).then((res: boolean) => {
            this.hasCachedUpdates = res
        })
    }

    public created() {
        this.running = true;
        this.onFrame();
    }

    public beforeDestroy() {
        this.running = false;
    }

    public saveRecord() {
        this.emitOnBus(SAVE_CURRENT_RECORD_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private shouldDisplayStateEntry(key: string) {
        return key !== this.recordState;
    }

    private onFrame() {
        this.onLine = window.navigator.onLine;
        if (this.running) {
            requestAnimationFrame(this.onFrame);
        }
    }

    private onStatusClick(state: RecordLifecycleState) {
        this.showValidation = true;
        this.selectedLifecycleState = state;
    }

    private transitionRecordToState() {
        this.emitOnBus(TRANSITION_RECORD_TO_STATE, { state: this.selectedLifecycleState })
    }

    private resetValidation() {
        this.selectedLifecycleState = null as any;
        this.showValidation = false;
    }
}